import { useEffect, useState, useRef } from "react";
import "../theme/Home.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { useNavigate, useLocation } from "react-router-dom";
import { CarrucelBanner } from "../components/CarrucelBanner";
import { fetchSecciones } from "../Api/fetchSecciones";
import { authProvider } from "../context/authProvider";
import { UseAuth, UseUser, UseAdmin } from "../hooks";
import { fetchBitacora } from "../Api/fetchBitacora";
import { VERSION_APP, ENVIROMENT } from "../utilities";
import moment from "moment";
import { remoteConfig, analytics } from "../firebase";
import { getValue, fetchAndActivate } from "firebase/remote-config";
import { logEvent } from "firebase/analytics";
import extractPermissions from "../utils/getUserPermissions";
import { setPermissions } from "../redux/permissionsSlice";
import { useRole } from "../context/RoleContext";
import { useDispatch } from "react-redux";
import { ModuleCard } from "../components/shared/ModuleCard";
import { HomeGridItemsSkeleton } from "../components/shared/HomeGridItemsSkeleton";

import { useColoresEmpresa } from "../hooks/useColoresEmpresa";
import { useBrandPreview } from "../context/BrandPreviewContext";
import { getBrandLogo } from "../const/brandLogos";
import { BRANDINGS_ICONS } from "../const/brandings";
import BRANDS from "../const/brands";
import { DateInfo } from "../components/shared/DateInfo";
import { CustomDrawer } from "../components/Drawer/CustomDrawer";
import { DrawerModuleContent } from "../components/shared/DrawerModuleContent";

export const HomePage = () => {
  const location = useLocation();
  const newCeco = location.state?.ceco;
  console.log('newCeco', newCeco)

  const dispatch = useDispatch();

  const { signIn, status } = UseAuth();
  const { userRol: rol } = useRole();
  const [dataHome, setDataHome] = useState();
  const [isLoadingModules, setIsLoadingModules] = useState(true);
  const { updateCeco, jobTitle, employeeId, mail, device, usuario, userIn } = UseUser();
  const {
    brandfiMarcaId,
    branchFiSucursalId,
    branchFiPaisId,
    brandfiBiId,
    rolId,
  } = UseAdmin();
  const { uniqueId } = UseAuth();
  const navigate = useNavigate();

  const pathname = location.pathname;


  const [isReporteShow, setIsReporteShow] = useState(false);
  const [isAdminShow, setIsAdminShow] = useState(false);
  const [reporteData, setReporteData] = useState(null);
  const [adminData, setAdminData] = useState(null);

  const brandId = useColoresEmpresa();
  const { previewBrand } = useBrandPreview();
  const activeBrandId = previewBrand || brandId;
  const { src: logoSrc, alt: logoAlt } = getBrandLogo(activeBrandId);

  // Estado para gestión de Drawer
  const [drawerState, setDrawerState] = useState({
    open: false,
    title: "",
    items: [],
    activeItemId: null,
  });

  // Configuración de items que deben mostrar Drawer
  const DRAWER_CONFIG = {
    navigateToMesaServicios: {
      enabled: true,
      title: "Gestión de Servicios",
    },
    // Todo: Agregar futuros items aquí
    // navigateToMensageria: {
    //   enabled: true,
    //   title: "Mensajería",
    // },
  };

  useEffect(() => {
    if (pathname === "/Home") {
      console.log("Estamos en home");
      console.log("status");
      if (status === "signIn" || status === "restoreToken") {
        getRemoteconfig();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, status]);

  const getRemoteconfig = async () => {
    console.log("Obtener informacion de variables de Remoteconfig");
    try {
      remoteConfig.settings.minimumFetchIntervalMillis = 60000;
      await fetchAndActivate(remoteConfig);
      const adminitracion =
        ENVIROMENT === "dev"
          ? "url_domain_api_administracion_dev"
          : "url_domain_api_administracion";
      const atb =
        ENVIROMENT === "dev" ? "url_domain_api_moduloAtb_dev" : "url_domain_api_moduloAtb";
      const cierreDia =
        ENVIROMENT === "dev" ? "url_domain_api_cierreDia_dev" : "url_domain_api_cierreDia";
      const frecuencias =
        ENVIROMENT === "dev" ? "url_domain_api_frecuencias_dev" : "url_domain_api_frecuencias";
      const horariosempleados =
        ENVIROMENT === "dev"
          ? "url_domain_api_horariosempleados_dev"
          : "url_domain_api_horariosempleados";
      const indicadores =
        ENVIROMENT === "dev" ? "url_domain_api_indicadores_dev" : "url_domain_api_indicadores";
      const usabilidad =
        ENVIROMENT === "dev" ? "url_domain_api_usabilidad_dev" : "url_domain_api_usabilidad";
      const reclasificacion =
        ENVIROMENT === "dev" ? "url_domain_api_reclasif_dev" : "url_domain_api_reclasif";

      const baseUrlRemoteAdminitracion = getValue(remoteConfig, adminitracion)._value;
      const baseUrlRemoteAtb = getValue(remoteConfig, atb)._value;
      const baseUrlRemoteCierreDia = getValue(remoteConfig, cierreDia)._value;
      const baseUrlRemoteFrecuencias = getValue(remoteConfig, frecuencias)._value;
      const baseUrlRemoteHorariosEmpleados = getValue(remoteConfig, horariosempleados)._value;
      const baseUrlRemoteIndicadores = getValue(remoteConfig, indicadores)._value;
      const baseUrlRemoteUsabilidad = getValue(remoteConfig, usabilidad)._value;
      const baseUrlRemoteReclasificacion = getValue(remoteConfig, reclasificacion)._value;

      localStorage.setItem("baseUrlAdministracion", baseUrlRemoteAdminitracion);
      // PARA PROBAR BACKEND LOCAL
      // localStorage.setItem("baseUrlAdministracion", 'http://localhost:8001/api/home/admon/v1/');
      localStorage.setItem("baseUrlAtb", baseUrlRemoteAtb);
      localStorage.setItem("baseUrlCierreDia", baseUrlRemoteCierreDia);
      localStorage.setItem("baseUrlfrecuencias", baseUrlRemoteFrecuencias);
      localStorage.setItem("baseUrlHorariosEmpleados", baseUrlRemoteHorariosEmpleados);
      localStorage.setItem("baseUrlIndicadores", baseUrlRemoteIndicadores);
      localStorage.setItem("baseUrlUsabilidad", baseUrlRemoteUsabilidad);
      localStorage.setItem("baseUrlReclasificacion", baseUrlRemoteReclasificacion);

      console.log("baseUrlRemoteAdminitracion", baseUrlRemoteAdminitracion);
      console.log("baseUrlRemoteAtb", baseUrlRemoteAtb);
      console.log("baseUrlRemoteCierreDia", baseUrlRemoteCierreDia);
      console.log("baseUrlRemoteFrecuencias", baseUrlRemoteFrecuencias);
      console.log("baseUrlRemoteHorariosEmpleados", baseUrlRemoteHorariosEmpleados);
      console.log("baseUrlRemoteIndicadores", baseUrlRemoteIndicadores);
      console.log("baseUrlRemoteUsabilidad", baseUrlRemoteUsabilidad);
      console.log("baseUrlRemoteReclasificacion", baseUrlRemoteReclasificacion);
    } catch (error) {
      console.error("Error al obtener los valore de remoteconfig:", error);
      throw error;
    }
  };


  useEffect(() => {
    console.log("authProviderHOME");
    if (!authProvider) {
      return;
    }
    const getAccessToken = async () => {
      const response = await authProvider.acquireTokenSilent({
        scopes: ["openid", "profile", "email", "offline_access", "user.read"],
        account: authProvider.accountInfo, // Replace with the scopes required for your API
      });
      const expiration = response.idTokenClaims.iat.toString();
      const token = await authProvider.getAccessToken();
      //console.log("token", response);
      const idToken = token.accessToken;
      // console.log("idToken", idToken);
      await signIn(idToken, expiration, response.uniqueId);

      const responseToken = await fetch(
        ` https://graph.microsoft.com/v1.0/me?$select=employeeID,displayName,givenName,jobTitle,mail,surname,companyName,onPremisesExtensionAttributes,lastPasswordChangeDateTime,accountEnabled,userPrincipalName`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      const responseJson = await responseToken.json();
      console.log(responseJson);

       const pais =
        responseJson.onPremisesExtensionAttributes.extensionAttribute1 != null
          ? responseJson.onPremisesExtensionAttributes.extensionAttribute1
          : "Mexico";

      const ceco =
        responseJson.onPremisesExtensionAttributes.extensionAttribute6 != null
          ? responseJson.onPremisesExtensionAttributes.extensionAttribute6
          : responseJson.employeeId != null
          ? responseJson.employeeId
          : "0";

      const enable = responseJson.accountEnabled;
      const userEnable = enable.toString();

      const employeeId =
        responseJson.onPremisesExtensionAttributes.extensionAttribute8 != null
          ? responseJson.onPremisesExtensionAttributes.extensionAttribute8
          : ceco;

      const usuario = responseJson.userPrincipalName.split("@")[0];

      var sBrowser,
        sUsrAg = navigator.userAgent;

      if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome";
      } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Apple Safari";
      } else if (sUsrAg.indexOf("Opera") > -1) {
        sBrowser = "Opera";
      } else if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
      } else if (sUsrAg.indexOf("MSIE") > -1) {
        sBrowser = "Microsoft Internet Explorer";
      }

      const device = `${sBrowser}-${navigator.platform}`;


      await userIn(
        responseJson.mail,
        responseJson.displayName,
        responseJson.jobTitle,
        pais,
        ceco,
        responseJson.companyName,
        userEnable,
        employeeId,
        device,
        usuario
      );

      if (newCeco) {
        await updateCeco(newCeco);
      }
      // console.log(responseJson);
    };

    getAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getDataSeccion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFiPaisId, brandfiMarcaId, jobTitle, branchFiSucursalId, rolId]);

  const getDataSeccion = () => {
    if (
      branchFiPaisId !== null &&
      branchFiSucursalId !== null &&
      brandfiMarcaId !== null &&
      jobTitle !== null &&
      rolId !== null
    ) {
      setIsLoadingModules(true);

      const onFailure = ({ error, config }) => {
        getBitacora(error, config, "Admin Secciones");
        setIsLoadingModules(false);
      };

      const onSuccess = ({ data, config }) => {
        getBitacora(data, config, "Admin Secciones");

        const allSections = data.body.seccion.CHILD1.map((item) => ({
          FCJSONSECCION2: item.FCJSONSECCION2,
          FCLINKSECCION2: item.FCLINKSECCION2,
          FCSEGUNDASECCION: item.FCSEGUNDASECCION,
          FCURLIMAGEN2: item.FCURLIMAGEN2,
          FISEGUNDASECCIONID: item.FISEGUNDASECCIONID,
          FCSTACKSECCION2: item.FCSTACKSECCION2,
          FCCHIL2: item.CHILD2,
        }));

        // Verificar y extraer Reportes
        const contieneReportes = allSections.some((item) => item.FCSEGUNDASECCION === "Reportes");
        setIsReporteShow(contieneReportes);

        if (contieneReportes) {
          const soloReportes = data.body.seccion.CHILD1.filter(
            (item) => item.FCSEGUNDASECCION === "Reportes"
          );
          setReporteData(soloReportes);
        }

        // Verificar y extraer Administración
        const contieneAdmin = allSections.some(
          (item) => item.FCSEGUNDASECCION === "Administración"
        );
        setIsAdminShow(contieneAdmin);

        if (contieneAdmin) {
          const soloAdministracion = data.body.seccion.CHILD1.filter(
            (item) => item.FCSEGUNDASECCION === "Administración"
          );
          setAdminData(soloAdministracion);
        }

        // Filtrar módulos del home (sin Reportes ni Administración)
        const extractedDataWithReporte = allSections.filter(
          (item) =>
            item.FCSEGUNDASECCION !== "Reportes" && item.FCSEGUNDASECCION !== "Administración"
        );

        const permissionsBySection = extractPermissions(data.body.seccion);
        dispatch(setPermissions(permissionsBySection));
        setDataHome(extractedDataWithReporte);
        setIsLoadingModules(false);
      };

      fetchSecciones(
        branchFiPaisId,
        brandfiMarcaId,
        jobTitle,
        branchFiSucursalId,
        VERSION_APP,
        Number(rolId)
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const getBitacora = async (data, config, description) => {
    const deviceWeb = `${uniqueId}-${device}`;
    const key = `${uniqueId}-${device}-${employeeId}`;
    const obtenerFechaEnFormato = () => {
      const ahora = moment();
      // Agrega 5 segundos a la fecha actual
      ahora.add(2, "seconds");
      const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
      return fechaEnFormato;
    };
    const fechaActualEnFormato = obtenerFechaEnFormato();
    if (brandfiMarcaId != null && config != null && data != null) {
      const onFailure = (error) => {};
      const onSuccess = ({ data }) => {};
      fetchBitacora(
        mail,
        deviceWeb,
        fechaActualEnFormato,
        key,
        config,
        data,
        description,
        VERSION_APP,
        employeeId,
        brandfiMarcaId,
        branchFiSucursalId,
        branchFiPaisId
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  // Mapa de funciones de navegación
  const navigationActions = {
    navigateToIndicadores: () => navigate("/Indicadores"),
    navigateToHUb: (url, child2) => navigate("/Hub", { state: { dataRouter: child2 } }),
    navigateToMesaServicios: (url, child2) =>
      navigate("/MesaServiciosPage", { state: { dataRouter: child2 } }),
    navigateToAsistencia: (url, child2) => navigate(`/${url}`, { state: { dataRouter: child2 } }),
    navigateToEvaluame: (url) => window.open(url, "_blank"),
    navigateToEnlace: (url) => window.open(url, "_blank"),
    navigateToCAEA: (url) => window.open(url, "_blank"),
    navigateToTerminalesBancarias: (url) => window.open(interpolateUrl(url), "_blank"),
    navigateToDecisionCenter: (url) => window.open(interpolateUrl(url), "_blank"),
    navigateToChildsMesaServicios: (url) => window.open(url, "_blank"),
    navigateToFuncionUrl: (url) => window.open(url, "_blank"),
    navigateToFuncionWithSSO: (url) => window.open(url, "_blank"),
    navigateToFuncionWithData: (url) => window.open(interpolateUrl(url), "_blank"),
    navigateToFuncionStack: (url, child2) => navigate(`/${url}`, { state: { dataRouter: child2 } }),
    navigateToTipoInventario: (url, child2) =>
      navigate("/ModuloInventarioGerente", { state: { dataRouter: child2 } }),
  };

  const interpolateUrl = (url) => {
    return url.replace(/\${([^}]+)}/g, (match, variable) => {
      const values = { branchFiPaisId, brandfiMarcaId, branchFiSucursalId, brandfiBiId, usuario };
      return values[variable] || match;
    });
  };

  const getInterpolatedHref = (item) => {
    let url = item.FCLINKSECCION2;

    if (rol && rol !== "unidad") {
      const regex = /([&?]pwd=)[^&]*/i;
      const rolesValue = rol === "director" ? "Alsea.2025@" : "Alsea.05";
      url = url.replace("SBMX${branchFiSucursalId}", usuario);
      url = url.replace(regex, `$1${rolesValue}`);
    }

    return interpolateUrl(url);
  };

  // Función para abrir el Drawer
  const openDrawer = (item) => {
    const config = DRAWER_CONFIG[item.FCJSONSECCION2];

    if (!config?.enabled) {
      console.warn(`Drawer no configurado para: ${item.FCJSONSECCION2}`);
      return;
    }

    setDrawerState({
      open: true,
      title: config.title || item.FCSEGUNDASECCION,
      items: item.FCCHIL2 || [],
      activeItemId: item.FISEGUNDASECCIONID,
    });

    logEvent(analytics, "drawer_opened", {
      mail,
      version: VERSION_APP,
      drawerTitle: config.title,
      moduleId: item.FISEGUNDASECCIONID,
      employeeId,
      brandfiMarcaId,
      branchFiSucursalId,
      branchFiPaisId,
      deviceInfo: device,
    });
  };

  // Función para cerrar el Drawer
  const closeDrawer = () => {
    setDrawerState({
      open: false,
      title: "",
      items: [],
      activeItemId: null,
    });
  };

  // Handler para items dentro del Drawer
  const handleDrawerItemClick = (item) => {
    const action = item.FCJSONSECCION3;

    // Si es link externo, abrirlo
    if (action === "navigateToChildsMesaServicios" || action === "navigateToFuncionWithData") {
      const url = interpolateUrl(item.FCLINKSECCION3);
      window.open(url, "_blank");
    } else {
      // Ejecutar acción correspondiente
      console.log("Acción no manejada en drawer:", action);
    }

    getBitacora("code 200", action, item.FCTERCERASECCION);
  };

  const handleModuleClick = (item) => {
    console.log("CLICK módulo:", {
      seccion: item.FCSEGUNDASECCION,
      action: item.FCJSONSECCION2,
      link: item.FCLINKSECCION2,
    });

    if (shouldUseDrawer(item)) {
      openDrawer(item);
      return;
    }
    const action = navigationActions[item.FCJSONSECCION2];

    if (action) {
      action(item.FCLINKSECCION2, item.FCCHIL2);
    }

    logEvent(analytics, "handleOnPressButton", {
      mail,
      version: VERSION_APP,
      handleClick: item.FCSEGUNDASECCION,
      seccion: item.FCJSONSECCION2,
      employeeId,
      brandfiMarcaId,
      branchFiSucursalId,
      branchFiPaisId,
      deviceInfo: device,
    });

    getBitacora("code 200", item.FCJSONSECCION2, item.FCSEGUNDASECCION);
  };

  const handleClickToReporte = () => {
    navigate("/Reporte", { state: { dataRouter: reporteData } });

    logEvent(analytics, "navigate_to_reporte", {
      mail,
      version: VERSION_APP,
      employeeId,
      brandfiMarcaId,
      branchFiSucursalId,
      branchFiPaisId,
    });
  };

  const handleClickToAdministracion = () => {
    navigate("/Administracion", { state: { dataRouter: adminData } });

    logEvent(analytics, "navigate_to_administracion", {
      mail,
      version: VERSION_APP,
      employeeId,
      brandfiMarcaId,
      branchFiSucursalId,
      branchFiPaisId,
    });
  };

  const isExternalLink = (actionType) => {
    return (
      actionType === "navigateToChildsMesaServicios" || actionType === "navigateToFuncionWithData"
    );
  };

  const shouldUseDrawer = (item) => {
    return DRAWER_CONFIG[item.FCJSONSECCION2]?.enabled;
  };

  return (
    <div className="body-home-background">
      <AzureAD provider={authProvider}>
        {({ authenticationState, accountInfo }) => {
          const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
          if (isAuthenticated) {
            return (
              <div className="body-home">
                {/* header */}
                <div className="home-header">
                  <div className="welcone-name">
                    <div
                      className={`wellcome-brand-logo ${activeBrandId === BRANDS.ITALIANNIS.id && "wellcome-brand-logo--italiannis"}`}
                    >
                      <img
                        className={`image-logo ${activeBrandId === BRANDS.ITALIANNIS.id && "image-logo--italiannis"}`}
                        src={logoSrc}
                        alt={logoAlt}
                      />
                    </div>

                    <div className="wellcome-content">
                      <div className="wellcome-content-title">
                        <p className="wellcome-content-grettings">¡Hola!</p>
                        <p className="wellcome-content-name">{accountInfo.account.name}</p>
                        <div className="divider" />
                      </div>

                      <DateInfo />
                    </div>
                  </div>

                  {/* banner */}
                  <div className="home-banner">
                    <CarrucelBanner />
                  </div>
                </div>

                {/* sub-header */}
                <div className="home-subheader">
                  <div className="home-subheader-left">
                    <p className="home-subheader-title">Mis aplicaciones</p>
                    <p className="home-subheader-subtitle">Seleccione un módulo para continuar</p>
                  </div>

                  <div className="home-subheader-right">
                    {isAdminShow && (
                      <button onClick={handleClickToAdministracion} className="button-sub-header">
                        <img
                          className="button-sub-header-icon"
                          src={BRANDINGS_ICONS.settingsIcon}
                          alt="Icono Administración"
                        />{" "}
                        Administración
                      </button>
                    )}

                    {isReporteShow && (
                      <button onClick={handleClickToReporte} className="button-sub-header">
                        <img
                          className="button-sub-header-icon"
                          src={BRANDINGS_ICONS.reportIcon}
                          alt="Icono Reporte"
                        />{" "}
                        Reportes
                      </button>
                    )}
                  </div>
                </div>

                {/* grid */}
                {isLoadingModules && <HomeGridItemsSkeleton count={6} />}

                {!isLoadingModules && dataHome && (
                  <div className="home-grid-container">
                    <div className="home-grid">
                      {dataHome.map((item) => {
                        const isItemExternalLink =
                          !shouldUseDrawer(item) && isExternalLink(item.FCJSONSECCION2);

                        return (
                          <ModuleCard
                            key={item.FISEGUNDASECCIONID}
                            item={item}
                            labelKey="FCSEGUNDASECCION"
                            imageKey="FCURLIMAGEN2"
                            variant={isItemExternalLink ? "link" : "button"}
                            href={isItemExternalLink ? getInterpolatedHref(item) : null}
                            onClick={() => handleModuleClick(item)}
                          />
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Drawer Component */}
                <CustomDrawer
                  open={drawerState.open}
                  onClose={closeDrawer}
                  title={drawerState.title}
                  width={520}
                  analyticsData={{
                    mail,
                    version: VERSION_APP,
                    employeeId,
                    brandfiMarcaId,
                    branchFiSucursalId,
                    branchFiPaisId,
                    deviceInfo: device,
                  }}
                >
                  <DrawerModuleContent
                    items={drawerState.items}
                    onItemClick={handleDrawerItemClick}
                    interpolateUrl={interpolateUrl}
                    analyticsData={{
                      mail,
                      version: VERSION_APP,
                      employeeId,
                      brandfiMarcaId,
                      branchFiSucursalId,
                      branchFiPaisId,
                      deviceInfo: device,
                    }}
                  />
                </CustomDrawer>
              </div>
            );
          }
        }}
      </AzureAD>
    </div>
  );
};
